// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Serif', 'Roboto Serif Fallback'","fontStyle":"normal"},"className":"__className_bfdd57","variable":"__variable_bfdd57"};